/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { getInfCLogger } from '@infodata-group/inf-commons-core';
import { DataModel } from '../../engine/data-model';
import { Observable } from 'rxjs';
import { TableManager } from './table-manager';
import { IEntity } from '../../interface/IEntity';

const logger = getInfCLogger('AsyncTableManager');

export class AsyncTableManager<T extends IEntity> extends TableManager<T> {
  public dataSource: Observable<T[]>;

  constructor(
    model: DataModel,
    dataSource: Observable<T[]>,
    struct?: string[],
    onGroup = false,
  ) {
    super(model, struct, onGroup);
    this.dataSource = dataSource;
  }

  /**
   * Return the dataSource Observable
   */
  public getEntities(): Observable<IEntity[]> {
    return this.loadSubject;
  }

  /**
   * Load dataSource and emit a load subject event
   */
  load(forceRefresh: boolean): void {
    if (forceRefresh || !this.data) {
      this.dataSource.subscribe({
        next: (result) => {
          // this.data = result.<map((e) => new TableEntity(e));
          result = result ?? [];
          this.data = result;
          if (this.selectedRow) {
            this.selectedRow = result.find(
              (d) => d.getId() === this.selectedRow.getId(),
            );
          }
          this._printableData = result;
          this.count = result.length;
          this.applyAllFilters();
        },
        error: (error) => {
          this.error = error;
        },
      });
    } else {
      this.applyAllFilters();
    }
  }

  changePage(page: number, step: number) {
    this.currentPage = page;
    void step;
  }

  changeStep(previousValue: number, newValue: number) {
    logger.debug(`Change step from "${previousValue}" -> "${newValue}"`);
    this.currentPage = 0;
  }

  initPage(page: number) {
    this.currentPage = page;
  }

  notifySort(data: any[]) {
    this.loadSubject.next(data);
  }
}
